import { portflioCategories } from "./categories";

const logo = require("./images/cssa.jpeg");

export { logo, portflioCategories };
